import { render, staticRenderFns } from "./partnersInformation.vue?vue&type=template&id=558d8380&scoped=true&"
import script from "./partnersInformation.vue?vue&type=script&lang=js&"
export * from "./partnersInformation.vue?vue&type=script&lang=js&"
import style0 from "./partnersInformation.vue?vue&type=style&index=0&id=558d8380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d8380",
  null
  
)

export default component.exports